"use strict";
/**
 * Contract for the Overview's "Top ads in the space" tab (NEW-2716) and the
 * weekly digest that fills it (NEW-2717). The digest is written once a week
 * alongside the account summary; the page only ever reads the stored copy.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TOP_AD_CRAFT_DIMENSIONS = exports.TOP_ADS_IN_SPACE_STATUSES = void 0;
exports.TOP_ADS_IN_SPACE_STATUSES = [
    "no_competitors",
    "pending",
    "ready",
];
/** The craft dimensions the detail view lists, in display order. */
exports.TOP_AD_CRAFT_DIMENSIONS = [
    { key: "format", label: "Format" },
    { key: "hook", label: "Hook" },
    { key: "offer", label: "Offer" },
    { key: "script", label: "Script" },
    { key: "persuasion", label: "Persuasion" },
    { key: "production", label: "Production" },
    { key: "visual", label: "Visual" },
    { key: "audio", label: "Audio" },
];
